module.exports = __webpack_public_path__ + "assets/e764a05c2c0799cac735a97ab6c9e1f8.mp3";